import { Component, inject, OnInit, DestroyRef, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NotificationsService } from '@/app/core/services/notifications.service';
import { Notification } from '@/app/shared/interfaces/notification.interface';
import { NotificationHelpers } from '@/app/shared/utils';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';

@Component({
    selector: 'qc-notification-bell',
    standalone: true,
    imports: [CommonModule, RouterLink, OverlayPanelModule, ButtonModule, RippleModule],
    templateUrl: './notification-bell.component.html',
    styleUrl: './notification-bell.component.css',
})
export class NotificationBellComponent implements OnInit {
    private notificationsService = inject(NotificationsService);
    private router = inject(Router);
    private destroyRef = inject(DestroyRef);

    unreadCount = this.notificationsService.unreadCount;
    
    // Use computed signal for reactive updates when new notifications arrive via WebSocket
    recentNotifications = computed(() => {
        const notifications = this.notificationsService.notifications();
        return notifications.slice(0, 5);
    });

    ngOnInit(): void {
        // Load initial notifications
        this.notificationsService
            .getNotifications()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                error: (error: unknown) => {
                    console.error('Error loading notifications:', error);
                },
            });
    }

    hasUrgentNotifications(): boolean {
        return this.recentNotifications().some((n: Notification) => n.priority === 'urgent' && !n.isRead);
    }

    handleNotificationClick(notification: Notification, overlay: any): void {
        // Mark as read
        if (!notification.isRead) {
            this.notificationsService.markAsRead(notification.id).subscribe({
                error: (error: unknown) => console.error('Error marking notification as read:', error),
            });
        }

        // Close overlay first
        overlay.hide();

        // Always navigate to notifications page
        this.router.navigate(['/notifications']);
    }

    getNotificationIcon(type: string): string {
        return NotificationHelpers.getNotificationIcon(type);
    }

    getTimeAgo(date: Date): string {
        return NotificationHelpers.getTimeAgo(date);
    }
}
